import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../config";
import "./ProjectDetails.css";

function ProjectDetails() {
  const { clientId, projectId } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/getProjectById/${clientId}/${projectId}`)
      .then((res) => setProject(res.data))
      .catch((err) => console.error("Error fetching project:", err));
  }, [clientId, projectId]);

  if (!project) {
    return <p className="project-details-loading">Loading project details...</p>;
  }

  return (
    <div className="project-details-page">
      <div className="project-details-card">
        <div className="project-details-header">
          <div>
            <p className="project-details-kicker">Project Overview</p>
            <h2 className="project-details-title">{project.projectName}</h2>
          </div>
          <Link
            to="/admin/projects"
            state={{ client: project.clientId }}
            className="project-details-back-btn"
          >
            Back to Projects
          </Link>
        </div>

        <div className="project-details-grid">
          <div className="project-details-item">
            <span className="label">Project ID</span>
            <span className="value mono">{project.projectId || "N/A"}</span>
          </div>

          <div className="project-details-item">
            <span className="label">Client</span>
            <span className="value">{project.clientId?.leadName || "N/A"}</span>
          </div>

          <div className="project-details-item">
            <span className="label">Department</span>
            <span className="value">{project.department?.deptName || "N/A"}</span>
          </div>

          <div className="project-details-item">
            <span className="label">Service</span>
            <span className="value">{project.service?.serviceName || "N/A"}</span>
          </div>

          <div className="project-details-item">
            <span className="label">Start Date</span>
            <span className="value">
              {project.startDate ? new Date(project.startDate).toLocaleDateString() : "N/A"}
            </span>
          </div>

          <div className="project-details-item">
            <span className="label">End Date</span>
            <span className="value">
              {project.endDate ? new Date(project.endDate).toLocaleDateString() : "N/A"}
            </span>
          </div>

          <div className="project-details-item">
            <span className="label">Category</span>
            <span className="value">{project.category || "N/A"}</span>
          </div>

          <div className="project-details-item">
            <span className="label">Budget</span>
            <span className="value budget">
              {typeof project.price !== "undefined" && project.price !== null
                ? `Rs. ${project.price}`
                : "N/A"}
            </span>
          </div>
        </div>

        <div className="project-details-section">
          <span className="label">Description</span>
          <p className="section-text">{project.projectDescription || "No description available."}</p>
        </div>

        <div className="project-details-section">
          <span className="label">Notes</span>
          <p className="section-text">{project.notes || "No notes available."}</p>
        </div>

        {project.addFile && (
          <div className="project-details-actions">
            <a
              href={`${API_URL}/uploads/projects/${project.addFile}`}
              target="_blank"
              rel="noreferrer"
              className="project-details-file-btn"
            >
              View Attached File
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectDetails;
